import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ReactGA from 'react-ga4'
import TagManager from 'react-gtm-module'
import { getAnalyticsIds, getGTMId } from '../../hocs/OptionsHOC/helpers'
import { getPermanentId } from '../../helpers/getPermanentId'
import { useGAContext } from '../../contexts/GAContext'

// Function for settings google analytics page view.
const gaPageView = analyticsIds => {
  const trackerNames = analyticsIds.map((id, index) => {
    return `tracker_${index}`
  })

  const pathname = window.location.pathname
  const href = window.location.href

  if (pathname.includes('expresshelp')) {
    const category = pathname.split('/')[2]?.split('?').shift()
    // if url is legacy skips data upload to analytic.
    // express help component automatically redirects to new url when legacy url is used.
    if (category?.replace(/[^0-9]/g, '').length !== 7) {
      ReactGA.pageview(href, trackerNames)
    }

  } else {
    ReactGA.pageview(href, trackerNames)
  }
}

// This is use to send Google Analytics page view and values of custom dimensions every after route update.
export const handleUpdate = state => {
  const { currentPhoneId } = state.devicebits
  const analyticsIds = getAnalyticsIds(state)
  ReactGA.set({
    dimension1: window.location.hostname,
    dimension2: currentPhoneId,
    dimension3: getPermanentId()
  })
  gaPageView(analyticsIds)
}

// This is used to initialize Google Analytics and Tag Manager
const InitializeGA = ({ analyticsIds, gtmId }) => {
  const { setInitialized } = useGAContext()
  useEffect(() => {
    const trackers = analyticsIds.map((id, index) => ({
      trackingId: id,
      gaOptions: { name: `tracker_${index}` }
    }))
    ReactGA.initialize(trackers)
    TagManager.initialize({
      gtmId
    })
    // Trigger first page view after initialization
    gaPageView(analyticsIds)

    // Setting Context state initialize to true
    setInitialized(true)
  }, [])

  return null
}

const mapStateToProps = state => ({
  analyticsIds: getAnalyticsIds(state),
  gtmId: getGTMId(state)
})

InitializeGA.propTypes = {
  analyticsIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  gtmId: PropTypes.string.isRequired
}

export default connect(mapStateToProps, null)(InitializeGA)



// WEBPACK FOOTER //
// ./src/containers/InitializeGA/index.js